import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { LPCoverFactory } from '../../pages/LPCreatePage/factory';
import { baseUrlEncoderGreyScale } from '../../utils/baseurl.encoder';
import ASpaceInBetweenAnother from '../ASpaceInBetweenAnother/a.space.inbetween.another.vue';

@Component({
    components: {
        ASpaceInBetweenAnother
    }
})
export default class LPCover extends Vue {
    public title: string = 'Comparaitive Market Analysis';

    @Prop({
        default: () => {
            return LPCoverFactory.addrFactory();
        }
    })
    public addr: any;

    @Prop({
        default: () => {
            return LPCoverFactory.preparedForFactory();
        }
    })
    public preparedFor: any;

    @Prop({
        default: () => {
            return LPCoverFactory.preparedByFactory();
        }
    })
    public preparedBy: any;

    @Prop({
        default: () => {
            return LPCoverFactory.agentBrokerageFactory();
        }
    })
    public agentBrokerage: any;

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    @Prop({ default: '' })
    public houseImg: any;

    // public houseImg = 'http://onepiece-test-oss.oss-us-west-1.aliyuncs.com/epic-test/imgs/rifo-design/houseDemo.jpg';

    public async created() {
        // this.houseImg = await baseUrlEncoderGreyScale(this.houseImg, 'image/png', 920, 600);
    }
}
